import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    methods: {
        ...mapActions('AdvertiserValidation', [
            'ActionSetAdvertiserValidationConversions',
            'ActionSetCampaignValidationHistory'
        ]),
        async approveValidations(preValidationIds) {
            return await this.$http.post('/v2/redirect', {
                app: 'CONVERSORPHP',
                path: `/api/pre-validate/conversion`,
                params: {
                    data: {
                        processed_by_user_id: this.user.user_id,
                        pre_validation_ids: preValidationIds,
                        action: "approve"
                    }
                }
            });
        },

        dateParse(date) {
            let dateArray = date.split('/');
            return `${dateArray[1]}-${dateArray[0]}-1`;
        },

        dateParseV2(date) {
            let dateArray = date.split('/');
            return `${dateArray[1]}-${dateArray[0]}`;
        },

        async getValidationResume() {
            return await this.$http.get(
                `/v2/redirect?app=REPORT&path=/api/transaction/history%3Fcampaign_id%3D${this.filter.campaign_id
                }%26periodo%3D${this.dateParse(this.filter.period)}`
            );
        }
    },
    computed: {
        ...mapGetters('AdvertiserValidation', ['advertiserValidationConversions', 'campaignValidationHistory']),
        ...mapState('AdvertiserValidation', ['filter'])
    }
};
